import moment from 'moment';
import { find } from 'ramda';

import { compareDate } from 'utils/date';

export const getFeedbackForDay = (date, days) => find(
  d => compareDate(date, moment.utc(d.date)),
  days
);
